import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import BreadcrumbsBg from "../Assets/img/breadcrumbs-bg.png";
import ContactFormBG from "../Assets/img/contact-form-bg.svg";
const ContactUs = ({ schoolInfo }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section
        className="eschool-breadcrumbs"
        style={{ backgroundImage: `url(${BreadcrumbsBg})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
              <div className="eschool-breadcrumbs-content">
                <h3 className="eschool-bread-cont-title">Contact Us</h3>
                <ul className="eschool-bread-menu">
                  <li>
                    <Link to="/">Home</Link>
                    <i class="fi fi-br-angle-right"></i>
                  </li>
                  <li className="active">
                    <Link to="/contactus">Contact Us</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-us-info-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-12">
              <div className="contact-us-info-box">
                <div className="contact-us-info-main">
                  <h4 className="contact-us-info-title">Get in touch</h4>
                  <p className="contact-us-info-text">
                    Have a inquiry or some feedback for us? Fill out the form
                    below to contact our team. please contact us at
                    hello@eschool.com.
                  </p>
                  <div className="contact-us-info-single">
                    <div className="contact-us-info-single-icon">
                      <i className="fi fi-rs-marker"></i>
                    </div>
                    <div className="contact-us-info-single-content">
                      {" "}
                      <h6 className="contact-us-info-single-title">
                        Office adress
                      </h6>
                      <p className="contact-us-info-single-text">
                        {schoolInfo?.address}
                      </p>
                    </div>
                  </div>
                  <div className="contact-us-info-single">
                    <div className="contact-us-info-single-icon">
                      <i className="fi fi-rr-phone-call"></i>
                    </div>
                    <div className="contact-us-info-single-content">
                      {" "}
                      <h6 className="contact-us-info-single-title">
                        Phonne number
                      </h6>
                      <ul class="contact-us-info-list">
                        <li>
                          <a href={`tel:${schoolInfo?.hot_number_1}`}>
                            {schoolInfo?.hot_number_1}
                          </a>
                        </li>
                        <li>
                          <a href={`tel:${schoolInfo?.hot_number_2}`}>
                            {schoolInfo?.hot_number_2}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="contact-us-info-single">
                    <div className="contact-us-info-single-icon">
                      <i className="fi fi-rr-envelope-open"></i>
                    </div>
                    <div className="contact-us-info-single-content">
                      <h6 className="contact-us-info-single-title">
                        Email address
                      </h6>
                      <ul class="contact-us-info-list">
                        <li>
                          <a href={`mailto:${schoolInfo?.email_1}`}>
                            {schoolInfo?.email_1}
                          </a>
                        </li>
                        <li>
                          <a href={`mailto:${schoolInfo?.email_2}`}>
                            {schoolInfo?.email_2}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-12">
              <div className="contact-us-info-map">
                <div className="gmap_canvas">
                  <iframe
                    width="434"
                    height="500"
                    id="gmap_canvas"
                    src="https://maps.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3651.0104336321297!2d90.41270911479724!3d23.782642793461232!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b165a1921a09%3A0xb58f02520cb0cb41!2sSoftifyBD%20Ltd.!5e0!3m2!1sen!2sbd!4v1669619081345!5m2!1sen!2sbd"
                    frameBorder="0"
                    scrolling="no"
                    marginHeight="0"
                    marginWidth="0"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-us-form-area">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12 col-xl-6 col-12">
              <div className="contact-us-form-content">
                <div className="contact-us-form-cont-top">
                  <span className="contact-form-cont-sm-title">
                    Contact with us!
                  </span>
                  <h4 className="contact-form-cont-big-title">
                    Have any questions?
                  </h4>
                  <p className="contact-form-cont-text">
                    It is a long established fact that a reader will be
                    distracted by the of a page when looking at its layout.
                    content here making it look like readable English.
                  </p>
                </div>
                <div className="contact-form-main">
                  <form action="#" method="post">
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <input
                            type="text"
                            name="name"
                            placeholder="Full name"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <input
                            type="email"
                            name="email"
                            placeholder="Email address"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <input
                            type="text"
                            name="phone-number"
                            placeholder="Phone number"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group select-option-arrow">
                          <i className="fi-rr-angle-small-down"></i>
                          <select
                            className="form-select "
                            aria-label=".form-select-lg example"
                          >
                            <option selected>Select topic</option>
                            <option value="1">Admission</option>
                            <option value="2">Admission fees</option>
                            <option value="3">Examination</option>
                            <option value="4">I just want to talk</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-group">
                          <textarea
                            name="message"
                            placeholder="Your message"
                            required
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="contact-form-button">
                          <button
                            type="submit"
                            method="post"
                            className="eschool-btn secondary-btn"
                          >
                            Send message
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-xl-6 col-12">
              <div className="contact-form-img">
                <img src={ContactFormBG} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
